export default "__VITE_ASSET__C0SP06h2__"